import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import dev_auth from "./dev_auth/dev_auth.js";
import store from "./store/store.js";
import Entrance from "./views/Entrance.vue";
import SignIn from "./views/SignIn";
import SignUp from "./views/SignUp";
import Reset_Password from "./views/Reset_Password";
import Authenticate_Product from "./views/Authenticate_Product";
import Verify_Mail from "./views/Verify_Mail";
import navigation_guards from "../src/navigationGuards";
import Action from "./views/Action";
import Products from "./views/Products";
import Settings from "./views/Settings";

import Profile from "./views/Profile";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requires_dev_auth: true,
        requires_auth: true,
        requires_verified_mail: true
      }
    },

    {
      path: "/entrance",
      name: "Entrance",
      component: Entrance,
      meta: {
        requires_dev_auth: false,
        requires_auth: false,
        requires_verified_mail: false
      }
    },
    {
      path: "/products",
      name: "Products",
      component: Products,
      meta: {
        requires_dev_auth: true,
        requires_auth: true,
        requires_verified_mail: true
      }
    },
    {
      path: "/settings",
      name: "Settings",
      component: Settings,
      meta: {
        requires_dev_auth: true,
        requires_auth: true,
        drawer_enabled: true
      }
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requires_dev_auth: true,
        requires_auth: true,
        requires_verified_mail: true
      }
    },

    {
      path: "/signin",
      name: "Sign In",
      component: SignIn,
      props: true,
      meta: {
        requires_dev_auth: true,
        requires_auth: false,
        requires_verified_mail: false
      },
      beforeEnter: (to, from, next) => {
        if (store.getters["user/is_logged_in"]) {
          if (to.query.auth_requester > "")
            next({
              name: "Authenticate Product",
              params: {
                auth_requester: to.query.auth_requester,
                auth_requester_title: to.query.auth_requester_title
              }
            });
          next("/");
        } else {
          next();
        }
      }
    },

    {
      path: "/reset_password",
      name: "Reset Password",
      component: Reset_Password,
      props: true,
      meta: {
        requires_dev_auth: true,
        requires_auth: false,
        requires_verified_mail: false
      }
    },
    {
      path: "/action",
      name: "Action",
      component: Action,
      meta: {
        requires_dev_auth: true,
        requires_auth: false,
        requires_verified_mail: false
      }
    },
    {
      path: "/signup",
      name: "Sign Up",
      component: SignUp,
      props: true,
      meta: {
        requires_dev_auth: true,
        requires_auth: false,
        requires_verified_mail: false
      },
      beforeEnter: (to, from, next) => {
        if (store.getters["user/is_logged_in"] === true) {
          next("/");
        } else {
          next();
        }
      }
    },
    {
      path: "/verify",
      name: "Verify Mail",
      component: Verify_Mail,
      props: true,
      meta: {
        requires_dev_auth: true,
        requires_auth: true,
        requires_verified_mail: false
      },

      beforeEnter: (to, from, next) => {
        if (store.getters["user/has_verified_mail"] === true) {
          next("/");
        } else {
          next();
        }
      }
    },
    {
      path: "/auth",
      name: "Authenticate Product",
      component: Authenticate_Product,
      props: true,
      meta: {
        requires_dev_auth: true,
        requires_auth: true,
        requires_verified_mail: true
      }
    },
    { path: "*", redirect: "/" }
  ]
});

//apply navigation-guard for dev and staging environments
if (dev_auth === true) {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requires_dev_auth)) {
      if (!store.getters["user/is_dev_authenticated"]) {
        window.location = "https://vetvise.com";
      } else {
        next();
      }
    } else {
      next();
    }
  });
}

router.beforeEach((to, from, next) => {
  let invoked = false;

  if (!to.params.override_guards) {
    let guards = [...navigation_guards];
    while (guards.length > 0 && !invoked) {
      const current_guard = guards.shift();
      let result = current_guard(to, from);

      if (result) {
        next({ path: result.path, params: result.params, query: result.query });
        invoked = true;
      }
    }
  }
  if (!invoked) {
    next();
  }
});

export default router;
